document.addEventListener('DOMContentLoaded', function () {
  // Detectar si el cliente está logueado
  const isLoggedIn = document.body.classList.contains('customer-logged-in');

  // Crear el modal
  const modal = document.createElement('div');
  modal.id = 'sinopsis-modal';
  modal.innerHTML = `
    <div id="sinopsis-modal-overlay">
      <div id="sinopsis-modal-content">
        <button id="sinopsis-modal-close">&times;</button>
        <div id="sinopsis-modal-body"></div>
      </div>
    </div>
  `;
  document.body.appendChild(modal);

  // Cerrar modal
  document.getElementById('sinopsis-modal-close').addEventListener('click', closeModal);
  document.getElementById('sinopsis-modal-overlay').addEventListener('click', function (e) {
    if (e.target === this) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  function closeModal() {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  // Mensaje de acceso restringido
  const accessDeniedHTML = `
    <div style="text-align:center;padding:20px;">
      <div style="font-size:48px;margin-bottom:16px;">🔒</div>
      <h2 style="margin-bottom:12px;">Contenido exclusivo para miembros</h2>
      <p style="color:#666;margin-bottom:8px;">Este contenido es exclusivo para miembros registrados.</p>
      <p style="color:#666;margin-bottom:24px;font-style:italic;">This content is exclusive to registered members.</p>
      <a href="/account/login" class="button" style="display:inline-block;margin-bottom:12px;width:100%;">
        🇪🇸 Iniciar sesión &nbsp;|&nbsp; 🇬🇧 Sign in
      </a>
      <a href="/account/register" class="button button--secondary" style="display:inline-block;width:100%;">
        🇪🇸 Crear cuenta gratis &nbsp;|&nbsp; 🇬🇧 Create free account
      </a>
    </div>
  `;

  // Añadir clic a cada tarjeta
  document.querySelectorAll('.multicolumn-list__item').forEach(function (item) {
    item.style.cursor = 'pointer';
    item.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') return;

      if (!isLoggedIn) {
        document.getElementById('sinopsis-modal-body').innerHTML = accessDeniedHTML;
      } else {
        const card = item.querySelector('.multicolumn-card');
        const image = card.querySelector('.multicolumn-card__image');
        const title = card.querySelector('h3');
        const text = card.querySelector('.rte');
        const link = card.querySelector('.link');

        let html = '';
        if (image) html += `<img src="${image.src}" alt="${image.alt}" style="width:100%;border-radius:12px;margin-bottom:20px;">`;
        if (title) html += `<h2 style="margin-bottom:16px;">${title.innerHTML}</h2>`;
        if (text) html += `<div style="margin-bottom:24px;">${text.innerHTML}</div>`;
        if (link) html += `<a href="${link.href}" target="_blank" class="button">${link.textContent.trim()}</a>`;

        document.getElementById('sinopsis-modal-body').innerHTML = html;
      }

      modal.style.display = 'block';
      document.body.style.overflow = 'hidden';
    });
  });
});
